import { useAppSelector, useAppDispatch } from "../../hook/store";
import { ESliceAuth, setAuthInfo, clearAuthInfo } from '../../store/slices/authSlice';
import { useEffect, useState } from "react";
import { removeBrowserState } from '../../store/browser-store';
import { APIGetUserInfoByToken } from '../../service/api/APIAuth';
import LoadingFullScreen from '../../components/global/Loading/LoadingFullScreen';


const GetUserInfo = ({ children }: { children: JSX.Element }) => {
    const storeState = useAppSelector(state => state)
    const user = storeState[ESliceAuth.AuthInfo]
    const dispatch = useAppDispatch()
    const isLogin = !!(user.company_uuid && user.access_token)
    const [isLoading, setIsLoading] = useState(!isLogin)



    useEffect(() => {
        if (isLogin) return

        const callUserInfo = async () => {
            if (user.access_token) {
                await APIGetUserInfoByToken().then(res => {
                    dispatch(setAuthInfo({
                        avatar: res.avatar,
                        username: res.email,
                        email: res.email,
                        is_active: res.is_active,
                        status: res.status,
                        permission: res.permissionData,
                        company_uuid: res.company_uuid,
                        firstname: res.firstname,
                        lastname: res.lastname
                    }))
                }).catch(() => {
                    dispatch(clearAuthInfo())
                    removeBrowserState()
                })

            } else {
                //wrong localstorage token
                dispatch(clearAuthInfo())
                removeBrowserState()
            }
            setIsLoading(false)
        }

        callUserInfo()
    }, [isLogin])

    if (isLoading) {
        // customLoading page
        return <LoadingFullScreen />
    }

    return children;
}


export default GetUserInfo